import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import LoadingArea from "../../components/LoadingArea";
import Dashboard from "../../layouts/Dashboard";
import axios from "../../services/axios";
import dateResolve from "../../services/dateResolve";
import * as yup from "yup";
import ReactMarkdown from "react-markdown";
import ReactMde from "react-mde";
import saveLog from "../../services/saveLog";
import swal from "sweetalert";
import { Card } from "antd";
import isConsultant from "../../services/isConsultant";

function Question({ query, reloadQuery }) {
  return (
    <div>
    {!isConsultant() && <Card className="card border mb-4" title={query.title}>
      {/* <div className="card-header">
        <h5 className="text-primary">{query.title}</h5>
      </div> */}
      <div>
        <div className="row">
          <div className="col-md-6">
            <strong>Description by the Candidate</strong>
            <p>{query.description}</p>
          </div>
          <div className="col-md-5">
            <div className="d-flex align-items-center">
              Asked By :
              {query.user ? (
                <Link
                  to={"/candidate/" + query.user?._id}
                  className="btn btn-link"
                >
                  {query.user?.name || "Deleted User"}
                </Link>
              ) : (
                <span className="text-danger">Deleted User</span>
              )}
            </div>
            <div>Asked On : {dateResolve(query.createdAt)}</div>
            <div className="mt-2">Solved : {query.solved ? "Yes" : "No"}</div>
          </div>
        </div>
        <hr />
        {query.solved ? (
          <EditAnswer query={query} reloadQuery={reloadQuery} />
        ) : (
          <WriteAnswer query={query} reloadQuery={reloadQuery} />
        )}
      </div>
    </Card>}
    </div>
  );
}

function WriteAnswer({ query, reloadQuery }) {
  // Stateful Hooks
  const initialValues = {
    answer: "",
  };
  const validationSchema = yup.object({
    answer: yup.string().trim().min(10).required().label("Answer"),
  });

  // Effects and Events
  async function handleCreate(values) {
    try {
      saveLog("QUERY_EDIT", `Answered a query (${query._id})`);
      await axios.patch(
        "/queries/" + query._id,
        { ...values, solved: true },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      );
      reloadQuery();
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div>
    {!isConsultant() && <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleCreate}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <div className="row">
          <div className="col-md-6">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>
                  <strong>Write an Answer</strong>
                </label>
                <ReactMde
                  value={values.answer}
                  onChange={(changes) => setFieldValue("answer", changes)}
                  childProps={{
                    previewButton: {
                      style: {
                        display: "none",
                      },
                    },
                    writeButton: {
                      style: {
                        display: "none",
                      },
                    },
                  }}
                />
                {/* <Field className="form-control" as="textarea" name="answer" /> */}
                <ErrorMessage
                  className="text-danger"
                  component="div"
                  name="answer"
                />
              </div>
              <div className="form-group d-flex align-items-center">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <small className="ml-4">
                  This will mark the question as solved.
                </small>
              </div>
            </form>
          </div>
          <div className="col-md-6">
            <label>
              <strong>Preview</strong>
            </label>
            <div>
              <ReactMarkdown>{values.answer}</ReactMarkdown>
            </div>
          </div>
        </div>
      )}
    </Formik>}
    </div>
  );
}

function EditAnswer({ query, reloadQuery }) {
  // Stateful Hooks
  const initialValues = {
    answer: query.answer,
  };
  const validationSchema = yup.object({
    answer: yup.string().trim().min(10).required().label("Answer"),
  });

  // Effects and Events
  async function handleCreate(values) {
    try {
      saveLog("QUERY_EDIT", `Updated a query (${query._id})`);
      await axios.patch(
        "/queries/" + query._id,
        { ...values, solved: true },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      );
      swal(
        "Answer Send Successfully!",
        "Thank you for submitting the answer",
        "success"
      );
      reloadQuery();
    } catch (e) {
      console.error(e);
    }
  }
  return (
    <div>
   {!isConsultant() &&  <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleCreate}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <div className="row">
          <div className="col-md-6">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>
                  <strong>Edit the Answer (MarkDown Supported)</strong>
                </label>
                <ReactMde
                  value={values.answer}
                  onChange={(changes) => setFieldValue("answer", changes)}
                  childProps={{
                    previewButton: {
                      style: {
                        display: "none",
                      },
                    },
                    writeButton: {
                      style: {
                        display: "none",
                      },
                    },
                  }}
                />
                {/* <Field className="form-control" as="textarea" name="answer" /> */}
                <ErrorMessage
                  className="text-danger"
                  component="div"
                  name="answer"
                />
              </div>
              <div className="form-group">
                <button className="btn btn-primary" type="submit">
                  Update
                </button>
              </div>
            </form>
          </div>
          <div className="col-md-6">
            <label>
              <strong>Preview</strong>
            </label>
            <div>
              <ReactMarkdown>{values.answer}</ReactMarkdown>
            </div>
          </div>
        </div>
      )}
    </Formik>}
    </div>
  );
}

function QueriesSingle() {
  // Stateful Hooks
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState();
  const { id } = useParams();

  // Effects and Events
  async function loadQuery() {
    try {
      const { data } = await axios.get("/queries/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setQuery(data);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    loadQuery();
  }, []);

  return (
    <div>
    {!isConsultant() && <Dashboard title="Queries">
      <LoadingArea isLoading={loading}>
        {query ? <Question query={query} reloadQuery={loadQuery} /> : null}
      </LoadingArea>
    </Dashboard>}
    </div>
  );
}

export default QueriesSingle;
